import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAppSelector as useSelector } from 'Store/index';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { getPatientAgeInMonths } from '../../../utility/patientInfo';
import Censorable from '../../../components/Censorable';
import TileContentMaker from '../../../components/DashboardTile/TileContentMaker';
import { ellipsis } from 'Components/DashboardTile/TileContentMaker/components/common/commonStyles';
import SSNWithFlag from 'Components/_NewElements/SSNWithFlag';

const ProfileDash = (): React.JSX.Element | undefined => {
  const { formatMessage } = useIntl();

  const patientData = useSelector((s: { patient: IPatientStore }) => s.patient.data);

  const ageInMonths =
    patientData?.isDead && isPartialDate(patientData?.dateOfDeath)
      ? getPatientAgeInMonths(patientData.dateOfDeath, true)
      : getPatientAgeInMonths(undefined, true);

  const _name = patientData ? `${patientData.lastNames?.toUpperCase()}, ${patientData.firstNames}` : '';
  const name = <Censorable>{_name}</Censorable>;

  const age = `${ageInMonths < 60 ? ageInMonths : Math.floor(ageInMonths / 12)}`;

  const gender = patientData?.gender ? (
    <FormattedMessage
      id={`general.${patientData?.gender === 'female' || patientData.gender === 'male' ? patientData?.gender : 'na'}`}
    />
  ) : (
    ''
  );

  const ageHeader = formatMessage({
    id:
      patientData?.isDead && ageInMonths < 60
        ? 'profile.ageOfDeathMonths'
        : patientData?.isDead
          ? 'profile.ageOfDeath'
          : !patientData?.isDead && ageInMonths < 60
            ? 'profile.ageMonths'
            : 'profile.ageYears',
  });

  return (
    <TileContentMaker
      type="bigHeaderInfo"
      bigHeaderText={<div style={{ ...ellipsis(38) }}>{name}</div>}
      data={[
        {
          title: formatMessage({ id: 'general.ssn' }),
          value: (
            <div
              style={{ lineHeight: 0, width: '', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
            >
              <SSNWithFlag patientData={patientData} iconSize={1.5} />
            </div>
          ),
          key: 'ssn',
        },
        { title: formatMessage({ id: 'profile.gender' }), value: gender, key: 'gender' },
        {
          title: ageHeader,
          value: age,
          key: 'age',
        },
        ...(patientData?.isDead
          ? [
              {
                title: formatMessage({ id: 'profile.dateOfDeath' }),
                value: isPartialDate(patientData?.dateOfDeath)
                  ? formatPartialDate(patientData?.dateOfDeath)
                  : undefined,
                key: 'dateOfDeath',
              },
              {
                title: formatMessage({ id: 'profile.causeOfDeath' }),
                value: patientData?.reasonOfDeath
                  ? patientData?.reasonOfDeath.reason !== 'other' && patientData?.reasonOfDeath?.reasonCode?.code
                    ? `${patientData.reasonOfDeath?.reasonCode?.code} ${patientData.reasonOfDeath?.reasonCode?.icd10description}`
                    : patientData?.reasonOfDeath?.reasonOther
                      ? patientData.reasonOfDeath?.reasonOther
                      : undefined
                  : undefined,
                key: 'causeOfDeath',
              },
              // {
              //   header: formatMessage({ id: 'profile.deathDetail' }),
              //   value: patientData?.reasonOfDeath?.reasonDetail || undefined,
              //   key: 'deathDetail',
              // },
            ]
          : []),
      ]}
    />
  );
};

export default ProfileDash;
